import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { Flex, FormControl, FormLabel, Stack } from '@chakra-ui/react'

import { DynamicAdvancedFilterInput, Loader } from 'components'
// import AdvancedMetadataFilter from './components/AdvancedMetadataFilter'

type MetadatasInfos = {
  label: string | number | boolean | Date
  type: string | number | boolean | Date
  name: string
}

type Props = {
  readMetadatasInfos?: (params?: any) => Promise<any>
  metadata: any
  register: any
  metadatasInfos: MetadatasInfos[]
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const MetadatasFilterForm: FC<Props> = ({
  // filter,
  // setFilter,
  metadatasInfos,
  register,
  metadata,
  readMetadatasInfos,
}) => {
  const [loadingMetadatasInfos, setLoadingMetadatasInfos] =
    useState(true)
  // const [infos] = useState<Array<{ label: string; value: string }>>([
  //   { label: 'Info 1', value: 'Value A' },
  //   { label: 'Info 2', value: 'Value B' },
  //   { label: 'Info 3', value: 'Value C' },
  // ])

  async function handleReadMetadatasInfos() {
    if (readMetadatasInfos) {
      setLoadingMetadatasInfos(true)
      const response = await readMetadatasInfos()
      if (response?.header?.success) {
        // executar algo
      }
    }
    setLoadingMetadatasInfos(false)
  }

  useEffect(() => {
    handleReadMetadatasInfos()
  }, [])

  if (!metadata.name) return null

  if (loadingMetadatasInfos) {
    return <Loader text="Carregando metadados" />
  }

  return (
    <Stack>
      {metadatasInfos.map(({ name, type, label }) => {
        if (!label) return null

        return (
          <FormControl key={name}>
            <Flex mb={2} align="center" justify="space-between">
              <FormLabel htmlFor={name}>{label as string}</FormLabel>
              {/* <AdvancedMetadataFilter label={label} infos={infos} name={name} filter={filter} setFilter={setFilter} /> */}
            </Flex>
            <DynamicAdvancedFilterInput
              register={register}
              name={name}
              type={type as string}
            />
          </FormControl>
        )
      })}
    </Stack>
  )
}

export default MetadatasFilterForm
